import { useMemo } from 'react';
import { isVcAgentBomSocketProcessingStatus } from 'utils/AICreatorHelper';

import type ISelectedUnits from 'store/slices/valueChainMap/interfaces/ISelectedUnits';

const useSessionUnitsPollingState = (selectedUnits: ISelectedUnits[] | undefined) => {
  const pollingSelectedUnitsKey = useMemo(
    () => (selectedUnits || [])
      .map((unit) => `${unit.unitId}:${unit.status}`)
      .join('|'),
    [selectedUnits],
  );

  const hasPollingSessionProcessingUnits = useMemo(
    () => selectedUnits?.some((unit) => isVcAgentBomSocketProcessingStatus(unit.status)) ?? false,
    [selectedUnits],
  );

  const selectedUnitStatusByUnitId = useMemo(
    () => new Map(
      (selectedUnits || []).map((unit) => [unit.unitId, unit.status] as const),
    ),
    [selectedUnits],
  );

  return { pollingSelectedUnitsKey, hasPollingSessionProcessingUnits, selectedUnitStatusByUnitId };
};

export default useSessionUnitsPollingState;
